// import firebase from "firebase/app";

import { initializeApp } from "firebase/app";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAuth } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const config = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG || "{}");

const app = initializeApp(config);
export const CloudFunctions = getFunctions(app);
// connectFunctionsEmulator(CloudFunctions, "127.0.0.1", 5001);
export const FirebaseAuth = getAuth(app);
export const Firestore = getFirestore(app);
// connectFirestoreEmulator(Firestore, '127.0.0.1', 8080);
export const FirebaseStorage = getStorage(app);
